export function getRawUrl(): string {
  const { host, pathname } = window.location;
  return `${host}${pathname}`;
}

export function getCurrentUrl(): string {
  return window.location.href;
}
